import React from 'react';
import styles from './FilterTabs.module.css';

const FilterTabs = ({
  tabs = [],
  activeTab,
  onTabChange,
  className = ''
}) => {
  return (
    <div className={`${styles.tabsContainer} ${className}`.trim()}>
      {tabs.map((tab) => {
        const id = typeof tab === 'object' ? tab.id : tab;
        const label = typeof tab === 'object' ? tab.label : tab;
        const count = typeof tab === 'object' ? tab.count : undefined;
        const isActive = activeTab === id;

        return (
          <button
            key={id}
            type="button"
            onClick={() => onTabChange(id)}
            className={`${styles.tabButton} ${isActive ? styles.active : ''}`.trim()}
          >
            <span>{label}</span>
            {count !== undefined && <span>{count}</span>}
          </button>
        );
      })}
    </div>
  );
};

export default FilterTabs;
